import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { swalAlertPopProps } from "../../utils/commonUtils";
import React, { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { ModalHeader } from "../../common/modalHeader";
import Swal from "sweetalert2";
const data = {
  categoryName: "",
  items: [],
};

export default function AddCategories({
  selectedCategories,
  section,
  selectedItems,
  setSelectedItems,
  allItems,
  open,
  addCategoriesData,
  updateCategoriesData,
  setOpen,
}) {
  const [itemData, setItemData] = useState(data);
  const onClose = () => {
    setRequiredError(false);
    setItemData(data);
    setOpen(false);
    setSelectedItems([]);
  };

  useEffect(() => {
    if (allItems && selectedCategories) {
      const aa = allItems?.filter((i) => {
        return i.itemCategoryId === selectedCategories?.id;
      });
      if (aa.length > 0) setSelectedItems([...aa]);
    }
  }, [allItems, selectedCategories]);

  useEffect(() => {
    if (selectedCategories) {
      setItemData({ ...itemData, ...selectedCategories });
    }
  }, [selectedCategories]);

  const [requiredError, setRequiredError] = useState(false);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="xs"
      onClose={() => {
        onClose();
      }}
    >
      <ModalHeader
        title={"List of Items"}
        onClose={(data) => {
          setRequiredError(false);
          setOpen(data);
          setItemData(data);
        }}
      />
      {/* <DialogTitle color="primary"></DialogTitle> */}

      <DialogContent sx={{ p: 1, overflow: "hidden" }}>
        <Box sx={{ mt: 2, paddingX: "1rem" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            value={itemData.categoryName}
            onChange={(e) => {
              setRequiredError(false);
              setItemData({ ...itemData, categoryName: e.target.value });
            }}
            label={
              <span>
                Item Category<span style={{ color: "red" }}>*</span>
              </span>
            }
          />
          {requiredError && (
            <Typography variant="body1" color="red" sx={{ margin: "5px" }}>
              Item Category is Required
            </Typography>
          )}
          <Box sx={{ maxHeight: "360px", overflowY: "auto", mt: 2 }}>
            <FormControl sx={{ width: "100%" }} component="fieldset">
              {allItems
                .filter((i) => {
                  if (selectedCategories) {
                    return (
                      i.itemCategoryId === 0 ||
                      i.itemCategoryId === selectedCategories?.id
                    );
                  } else {
                    return i.itemCategoryId === 0;
                  }
                })
                .sort((a, b) => {
                  const aChecked = selectedItems.some(
                    (item) => item.id === a.id
                  )
                    ? 1
                    : 0;
                  const bChecked = selectedItems.some(
                    (item) => item.id === b.id
                  )
                    ? 1
                    : 0;
                  return bChecked - aChecked;
                })
                ?.map((item2, index) => {
                  return (
                    <FormGroup
                      sx={{ width: "100%" }}
                      aria-label="position"
                      row
                      key={"notAssigntable" + index}
                    >
                      <FormControlLabel
                        sx={{
                          width: "100%",
                          justifyContent: "space-between",
                          px: 2,
                          m: 0,
                          "& .MuiTypography-root": {
                            fontWeight: "500",
                            fontSize: "15px",
                            color: "#000000",
                          },
                        }}
                        control={
                          <Checkbox
                            sx={{
                              color: "#000031",
                              "&.Mui-checked": {
                                color: "#000031",
                              },
                            }}
                            checked={
                              selectedItems.findIndex(
                                (item) => item.id === item2.id
                              ) !== -1
                            }
                            onChange={(e) => {
                              if (
                                selectedItems.findIndex(
                                  (item) => item.id === item2.id
                                ) !== -1
                              ) {
                                const tempArry = [...selectedItems];
                                const ind = tempArry.findIndex(
                                  (i) => i.id === item2.id
                                );

                                if (ind !== -1) tempArry.splice(ind, 1);

                                setSelectedItems([...tempArry]);
                              } else {
                                const tempArry = [
                                  ...selectedItems,
                                  { ...item2, isActive: true },
                                ];
                                setSelectedItems([...tempArry]);
                              }
                            }}
                          />
                        }
                        label={item2?.itemDescription}
                        labelPlacement="start"
                      />
                    </FormGroup>
                  );
                })}
            </FormControl>
          </Box>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          sx={{ width: "70%" }}
          variant="contained"
          onClick={() => {
            if (selectedItems?.length && itemData.categoryName) {
              if (section) {
                let arr = [...selectedItems];
                const arrcp = arr.map((item) => {
                  return {
                    itemDescription: item.itemDescription,
                    itemId: item.id,
                    itemCategoryId: item.itemCategoryId,
                  };
                });
                updateCategoriesData({ ...itemData, items: arrcp });
              } else {
                let arr = [...selectedItems];
                const arrcp = arr.map((item) => {
                  return {
                    itemDescription: item.itemDescription,
                    itemId: item.id,
                  };
                });
                addCategoriesData({ ...itemData, items: arrcp });
              }
              setOpen(false);
              setItemData(data);
            } else {
              // Swal.fire({
              //   title: "All Fields Are Required",
              //   icon: "warning",
              //   ...swalAlertPopProps,
              // });
              setRequiredError(true);
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
